import { Cell } from './Cell.js'

export function ShortsColumn() {
  return (
    <div className="flex flex-col gap-3 h-full">
      <Cell cell="short_x50" />
      <Cell cell="short_x25" />
      <Cell cell="short_x10" />
    </div>
  )
}
